import { useContext } from 'react';
import { isEmpty } from 'underscore';
import { StoreContext } from '../store/store';

export function setDateRangeLimit(
  startDate: moment.Moment,
  endDate: moment.Moment,
  advanced: boolean
) {
  let range: [moment.Moment, moment.Moment] = [startDate, endDate];
  if (advanced) return range;

  const start = startDate;
  const end = endDate;
  const rangeLimit = end.clone().subtract(1, 'years');

  range = [rangeLimit, end];
  if (rangeLimit.isBetween(start, end)) return range;

  range = [start, end];
  return range;
}
